import { render, staticRenderFns } from "./IncomeList.vue?vue&type=template&id=c8055794"
import script from "./IncomeList.vue?vue&type=script&lang=js"
export * from "./IncomeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports